import { PreventOverflowModifier } from '@popperjs/core/lib/modifiers/preventOverflow';
import { isBoolean } from 'lodash-es';
import {
  GenerateBoundingClient,
  PopoverContainerProps,
  PreventOverflowConfiguration,
} from './types';

export const generateGetBoundingClientRect = (
  x = 0,
  y = 0,
): GenerateBoundingClient => {
  return () => ({
    width: 0,
    height: 0,
    top: y,
    right: x,
    bottom: y,
    left: x,
  });
};

function isPreventOverflowConfig(
  value: undefined | boolean | PreventOverflowConfiguration,
): value is PreventOverflowConfiguration {
  if (value === undefined || isBoolean(value)) {
    return false;
  }

  return true;
}

export function preventOverflowModifier(
  preventOverflow: PopoverContainerProps['preventOverflow'],
): Partial<PreventOverflowModifier> {
  return {
    name: 'preventOverflow',
    // NB: this is an important evaluation.  `enabled` will be false if `preventOverflow`
    // is false or undefined and it will be true if `preventOverflow` is true or defined
    enabled: !!preventOverflow,
    options: isPreventOverflowConfig(preventOverflow)
      ? {
          altAxis: preventOverflow.altAxis,
          mainAxis: preventOverflow.mainAxis,
        }
      : undefined,
  };
}
